<template>
  <div id="app">
    <Form v-bind:Config="Config" />
  </div>
</template>

<script>
import Form from "./components/Form.vue";
import { Config } from "./components/config.js";

export default {
  name: "app",
  components: {
    Form
  },
  data: function() {
    return {
      'Config': Config
    }
  }
};
</script>